import { createPortal } from 'react-dom';
import { ReactNode } from 'react';

type PropsType = {
  children: ReactNode;
};

const ModalRootPortal = ({ children }: PropsType) => {
  const modalRoot = document.getElementById('modal-root');

  // NOTE: solve issue with typescript bug with createPortal
  return modalRoot ? (createPortal(children, modalRoot) as unknown as JSX.Element) : null;
};

export default ModalRootPortal;
